<template>
  <div class="integral-look">
    <Breadcrumb :crumb="crumb" />
    <div class="contain">
      <div class="top">
        <el-button
          size="text"
          icon="el-icon-arrow-left"
          class="but-black"
          @click="closeRule"
        >
          返 回
        </el-button>
      </div>

      <!-- 列表 -->
      <rule-table
        :table-data-rule="tableDataRule"
        :table-label="tableLabel"
      ></rule-table>

      <!-- 分页 -->
      <pagination
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import RuleTable from "@/components/RuleTable.vue";
import Pagination from "@/components/Pagination.vue";
import { mapState } from "vuex";
export default {
  components: {
    Breadcrumb,
    RuleTable,
    Pagination,
  },
  data() {
    return {
      tableDataRule: [],
      tableLabel: [],
      scoreMenuCode: "",

      currentMenuCode: null,
      //面包屑
      crumb: {
        list: ["积分规则"],
        //titBig:"默认为list最后一位，也可更改"
      },
      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30],
      },
    };
  },
  created() {
    let { menuCode, menuName } = this.scoreMenuList.find((item) =>
      this.$route.path.indexOf(item.menuCode) > -1
    );
    this.scoreMenuCode = menuCode;
    this.crumb.list.unshift(menuName);
    this.getHttp(1, this.pageObj.size);
  },
  computed: {
    ...mapState(["scoreMenuList", "userInfo"]),
  },
  methods: {
    getHttp(curPage, pageSize) {
      let selectForm = {
        schoolCode: this.userInfo.schoolCode,
        integralModel: this.scoreMenuCode || "",
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
      };
      this.$axios
        .post("/integralRule/getTeacherIntegralRuleListByUser", selectForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableDataRule = res.data.records;
            this.tableLabel = [
              { label: "类型", param: "integralName", align: "left" },
              { label: "积分", param: "integralNum", width: "200" },
            ];
          } else {
            console.log("列表查询积分规则error", res);
          }
        })
        .catch((err) => {
          console.log("列表查询catch error", err);
        });
    },

    closeRule() {
      this.$emit("closeRule");
    },

    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.getHttp(1, pageSize);
    },
    handleCurrentChange(curPage) {
      this.getHttp(curPage);
    },
  },
};
</script>

<style lang="less" scoped>
.integral-look {
  padding: 18px;
  .contain {
    background: #fff;
    border-radius: 18px;
    padding: 15px;
    .top {
      height: 57px;
    }
  }
}
</style>
